// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3383":"1e80fda9","8010":"aed2e31e"}[chunkId] + ".chunk.css";
};